<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>老师管理</Breadcrumb-item>
        <Breadcrumb-item>外教异动风险监测</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="80" :show-message="false" label-position="right">
        <Row :gutter="16">
          <i-col :xs="24" :sm="12" :lg="6">
            <Form-item label="老师ID">
              <Input v-model="queryParam.tchId" placeholder="精确匹配"></Input>
            </Form-item>
          </i-col>
          <i-col :xs="24" :sm="12" :lg="6">
            <Form-item label="老师姓名">
              <Input v-model="queryParam.tchName" placeholder="支持模糊搜索"></Input>
            </Form-item>
          </i-col>
          <i-col :xs="24" :sm="12" :lg="6">
            <Form-item label="外管">
              <Select v-model.number="queryParam.studyAdviserId" placeholder="全部"
                      @on-change="search" clearable filterable transfer>
                <Option v-for="item in studyAdviserList"
                        :value="item.id" :key="item.id">{{ item.nickname }}
                </Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :xs="24" :sm="12" :lg="6">
            <Form-item label="风险等级">
              <Select v-model="queryParam.level" placeholder="全部" clearable transfer>
                <Option v-for="item in levelOptions" :value="item" :key="item">{{ item }}</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :xs="24" :sm="12" :lg="6">
            <Form-item label="只看异动">
              <Checkbox v-model="queryParam.onlyAnomaly">风险分≥异动线</Checkbox>
            </Form-item>
          </i-col>
          <i-col :xs="24" :sm="12" :lg="6">
            <Form-item label="老师分类">
              <Select v-model="queryParam.channel" placeholder="全部" clearable transfer>
                <Option v-for="item in $constant.tchChannel"
                        :value="item.code" :key="item.code">{{ item.text }}
                </Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :xs="24" :sm="12" :lg="6">
            <Form-item label="统计窗口">
              <Date-picker
                type="month"
                format="yyyy-MM"
                placeholder="选择月份"
                v-model="monthDate"
                clearable
                style="width: 100%;"
                @on-change="onStatMonthChange"
              ></Date-picker>
            </Form-item>
          </i-col>
          <i-col :xs="24" :sm="24" :lg="12">
            <Form-item label="全周期">
              <Date-picker
                type="daterange"
                format="yyyy-MM-dd"
                v-model="dateRange"
                placeholder="请选择时间范围"
                clearable
                style="width: 100%;"
                @on-change="onWindowChange"
              ></Date-picker>
            </Form-item>
          </i-col>
        </Row>
      </Form>
    </div>
    <div class="btn-container">
      <Row>
        <Button type="primary" :loading="searchLoading" icon="search" @click="search">搜索</Button>
        <Button style="margin-left: 8px;" @click="reset">重置</Button>
        <Button style="margin-left: 8px;" @click="openRuleModal">规则设置</Button>
      </Row>
    </div>
    <div class="level-bar">
      <span
        v-for="item in levelOptions"
        :key="item"
        class="level-item"
        :class="{ 'level-item-active': queryParam.level === item }"
        @click="filterByLevel(item)">
        <span class="level-dot" :style="{ background: levelColor(item) }"></span>
        {{ item }}：<b>{{ levelCounts[item] || 0 }}</b>
      </span>
    </div>
    <div class="list-table">
      <Table :columns="columns" :data="dataList" :loading="searchLoading" stripe></Table>
      <div style="margin-top: 12px; text-align: right;">
        <Page
          :total="totalCount"
          :current="queryParam.pageIndex"
          :page-size="queryParam.pageSize"
          show-total
          show-sizer
          @on-change="onPageChange"
          @on-page-size-change="onPageSizeChange"
        ></Page>
      </div>
    </div>
    <Modal
      v-model="showRuleModal"
      title="异动风险规则设置"
      width="1100"
      :mask-closable="false"
      transfer>
      <Spin v-if="ruleLoading" fix></Spin>
      <div v-if="ruleConfig">
        <Form :label-width="100" :show-message="false" label-position="right">
          <Row :gutter="16">
            <Col :span="6">
              <Form-item label="回溯月数">
                <InputNumber v-model="ruleConfig.lookbackMonths" :min="6" :max="36" :step="1"></InputNumber>
              </Form-item>
            </Col>
            <Col :span="6">
              <Form-item label="升级单条权重">
                <InputNumber v-model="ruleConfig.upgradeWeight" :min="1" :max="20" :step="1"></InputNumber>
              </Form-item>
            </Col>
            <Col :span="6">
              <Form-item label="异动线">
                <InputNumber v-model="ruleConfig.anomalyScore" :min="1" :step="1"></InputNumber>
              </Form-item>
            </Col>
          </Row>
          <Row :gutter="16">
            <Col :span="6">
              <Form-item label="高危 ≥">
                <InputNumber v-model="ruleConfig.high" :min="1" :step="1"></InputNumber>
              </Form-item>
            </Col>
            <Col :span="6">
              <Form-item label="中危 ≥">
                <InputNumber v-model="ruleConfig.medium" :min="1" :step="1"></InputNumber>
              </Form-item>
            </Col>
            <Col :span="6">
              <Form-item label="观察 ≥">
                <InputNumber v-model="ruleConfig.watch" :min="1" :step="1"></InputNumber>
              </Form-item>
            </Col>
            <Col :span="6">
              <Form-item label="提示 ≥">
                <InputNumber v-model="ruleConfig.hint" :min="1" :step="1"></InputNumber>
              </Form-item>
            </Col>
          </Row>
        </Form>
        <div class="rule-table-wrap">
          <table class="rule-table">
            <thead>
              <tr>
                <th style="width: 50px;">编号</th>
                <th style="width: 80px;">分组</th>
                <th style="width: 140px;">规则</th>
                <th>判定说明</th>
                <th style="width: 230px;">参数</th>
                <th style="width: 80px;">权重</th>
                <th style="width: 90px;">互斥组</th>
                <th style="width: 60px;">启用</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="rule in ruleConfig.rules" :key="rule.code" :class="{ 'rule-disabled': !rule.enabled }">
                <td>{{ rule.code }}</td>
                <td>{{ rule.groupName }}</td>
                <td>{{ rule.name }}</td>
                <td class="rule-desc">{{ rule.desc }}</td>
                <td>
                  <span v-if="!rule.params || !rule.params.length" class="rule-muted">无</span>
                  <div v-for="p in rule.params" :key="p.key" class="rule-param">
                    <span class="rule-param-label">{{ p.label }}</span>
                    <InputNumber v-model="p.value" :min="0" :step="paramStep(p)" size="small" style="width: 80px;"></InputNumber>
                  </div>
                </td>
                <td>
                  <InputNumber v-model="rule.weight" :min="0" :max="20" :step="1" size="small" style="width: 64px;"></InputNumber>
                </td>
                <td>
                  <Input v-model="rule.mutexGroup" size="small"></Input>
                </td>
                <td>
                  <i-switch v-model="rule.enabled" size="small"></i-switch>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div slot="footer">
        <Button @click="showRuleModal=false">取消</Button>
        <Button :loading="ruleResetLoading" @click="resetRules">恢复默认</Button>
        <Button type="primary" :loading="ruleSaveLoading" :disabled="!ruleConfig" @click="saveRules">保存</Button>
      </div>
    </Modal>
    <Modal
      v-model="showLeaveDetailModal"
      :title="leaveDetailTitle"
      width="960"
      transfer>
      <div class="detail-summary" v-if="leaveDetail">
        区间：{{ leaveDetail.windowStart || '—' }} ~ {{ leaveDetail.windowEnd || '—' }}
        <span style="margin-left: 16px;">{{ leaveDetailValueText }}</span>
      </div>
      <Table :columns="leaveColumns" :data="leaveDetailLeaves" :loading="leaveDetailLoading"
             size="small" stripe></Table>
      <div v-if="leaveDetailMetric === 'singleMax'" style="margin-top: 16px;">
        <div class="detail-sub-title">受影响课节</div>
        <Table :columns="lessonColumns" :data="leaveDetailLessons" :loading="leaveDetailLoading"
               size="small" stripe></Table>
      </div>
      <div slot="footer">
        <Button @click="showLeaveDetailModal=false">关闭</Button>
      </div>
    </Modal>
    <tch-info-modal
      :value="showTchInfoModal"
      @on-close="showTchInfoModal=false"
      :tchId="tchInfoId"
    ></tch-info-modal>
  </div>
</template>
<script>
import TchInfoModal from './modal/TchInfoModal.vue'
import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'
const LEVEL_OPTIONS = ['高危', '中危', '观察', '提示', '正常']
const LEVEL_COLORS = {
  '高危': '#ed3f14',
  '中危': '#ff9900',
  '观察': '#f5c518',
  '提示': '#2d8cf0',
  '正常': '#19be6b'
}
// iView 2.8 的 Tag 只支持 blue/green/red/yellow，中危的橙色用自定义样式
const LEVEL_TAG_COLORS = {
  '高危': 'red',
  '观察': 'yellow',
  '提示': 'blue',
  '正常': 'green'
}
const METRIC_TITLES = {
  lastMonth: '上月请假明细',
  total: '全周期请假明细',
  continuous: '最长连续请假明细',
  singleMax: '单次最多课节明细'
}
function emptyQuery () {
  return {
    pageIndex: 1,
    pageSize: 20,
    tchId: '',
    tchName: '',
    studyAdviserId: '',
    level: '',
    onlyAnomaly: false,
    channel: null
  }
}
function pad2 (n) {
  return n < 10 ? '0' + n : '' + n
}
function monthStringToDate (ym) {
  if (!ym || typeof ym !== 'string') {
    return ''
  }
  let parts = ym.split('-')
  if (parts.length < 2) {
    return ''
  }
  let y = Number(parts[0])
  let m = Number(parts[1])
  if (!y || !m) {
    return ''
  }
  return new Date(y, m - 1, 1)
}
function toMonthString (v) {
  if (!v) {
    return ''
  }
  if (typeof v === 'string') {
    return v.length >= 7 ? v.slice(0, 7) : ''
  }
  if (Object.prototype.toString.call(v) === '[object Date]' && !isNaN(v.getTime())) {
    return v.getFullYear() + '-' + pad2(v.getMonth() + 1)
  }
  return ''
}
function toDayString (v) {
  if (!v) {
    return ''
  }
  if (typeof v === 'string') {
    return v.length >= 10 ? v.slice(0, 10) : ''
  }
  if (Object.prototype.toString.call(v) === '[object Date]' && !isNaN(v.getTime())) {
    return v.getFullYear() + '-' + pad2(v.getMonth() + 1) + '-' + pad2(v.getDate())
  }
  return ''
}
function isPositive (v) {
  return typeof v === 'number' && !isNaN(v) && v > 0
}
function isInt (v) {
  return typeof v === 'number' && Math.floor(v) === v
}
function errMsg (res, def) {
  return (res && (res.msg || res.message)) || def
}
export default {
  name: 'TchRiskWarningList',
  components: { TchInfoModal },
  data () {
    return {
      levelOptions: LEVEL_OPTIONS,
      searchLoading: false,
      rankScoreSeq: 0,
      showTchInfoModal: false,
      tchInfoId: null,
      dataList: [],
      totalCount: 0,
      levelCounts: {},
      studyAdviserList: [],
      monthDate: '',
      dateRange: [],
      statMonth: '',
      windowStart: '',
      windowEnd: '',
      appliedStatMonth: '',
      appliedWindowStart: '',
      appliedWindowEnd: '',
      fillingWindow: false,
      queryParam: emptyQuery(),
      columns: [],
      showRuleModal: false,
      ruleLoading: false,
      ruleSaveLoading: false,
      ruleResetLoading: false,
      ruleConfig: null,
      showLeaveDetailModal: false,
      leaveDetailLoading: false,
      leaveDetailTitle: '',
      leaveDetailMetric: '',
      leaveDetail: null,
      leaveDetailSeq: 0,
      leaveColumns: [],
      lessonColumns: []
    }
  },
  computed: {
    leaveDetailLeaves () {
      return (this.leaveDetail && this.leaveDetail.leaves) || []
    },
    leaveDetailLessons () {
      return (this.leaveDetail && this.leaveDetail.lessons) || []
    },
    leaveDetailValueText () {
      let d = this.leaveDetail
      if (!d) {
        return ''
      }
      let v = d.value == null ? 0 : d.value
      if (this.leaveDetailMetric === 'continuous') {
        return '连续 ' + v + ' 天'
      }
      if (this.leaveDetailMetric === 'singleMax') {
        return v + ' 节'
      }
      return '共 ' + v + ' 次'
    }
  },
  created () {
    let self = this
    this.columns = [
      { title: '排名', key: 'rank', width: 60, align: 'center' },
      { title: '老师ID', key: 'tchId', width: 80, align: 'center' },
      {
        title: '老师姓名',
        key: 'tchName',
        width: 150,
        render: (h, params) => {
          let row = params.row || {}
          let name = row.tchName || (row.tchId == null ? '' : String(row.tchId))
          if (!row.tchId) {
            return h('span', name || '—')
          }
          return renderTchNameWithScore(h, {
            text: name,
            score: row.monthRankScore,
            onClick: () => self.openTchInfoModal(row.tchId)
          })
        }
      },
      {
        title: '外管',
        key: 'studyAdviserName',
        width: 90,
        render: (h, params) => {
          return h('span', params.row.studyAdviserName || '—')
        }
      },
      { title: '风险分', key: 'riskScore', width: 70, align: 'center' },
      {
        title: '风险等级',
        key: 'level',
        width: 80,
        align: 'center',
        render: (h, params) => {
          return self.renderLevelTag(h, params.row.level)
        }
      },
      {
        title: '命中规则',
        key: 'hitRules',
        width: 380,
        render: (h, params) => {
          let rules = params.row.hitRules || []
          if (!rules.length) {
            return h('span', { style: { color: '#bbb' } }, '—')
          }
          return h('div', { style: { padding: '4px 0' } }, rules.map(function (r) {
            return self.renderHitRule(h, r)
          }))
        }
      },
      {
        title: '上月请假次数',
        key: 'lastMonthLeaveCount',
        width: 100,
        align: 'center',
        render: (h, params) => {
          return self.renderMetricCell(h, params.row, 'lastMonthLeaveCount', 'lastMonth')
        }
      },
      {
        title: '全周期请假次数',
        key: 'totalLeaveCount',
        width: 110,
        align: 'center',
        render: (h, params) => {
          return self.renderMetricCell(h, params.row, 'totalLeaveCount', 'total')
        }
      },
      {
        title: '最长连续请假天数',
        key: 'maxContinuousDays',
        width: 120,
        align: 'center',
        render: (h, params) => {
          return self.renderMetricCell(h, params.row, 'maxContinuousDays', 'continuous')
        }
      },
      {
        title: '单次最多课节',
        key: 'maxSingleLessons',
        width: 100,
        align: 'center',
        render: (h, params) => {
          return self.renderMetricCell(h, params.row, 'maxSingleLessons', 'singleMax')
        }
      }
    ]
    this.leaveColumns = [
      { title: '请假ID', key: 'id', width: 80, align: 'center' },
      {
        title: '开始时间',
        key: 'startTime',
        width: 140,
        render: (h, params) => {
          return h('span', self.formatUnix(params.row.startTime))
        }
      },
      {
        title: '结束时间',
        key: 'endTime',
        width: 140,
        render: (h, params) => {
          return h('span', self.formatUnix(params.row.endTime))
        }
      },
      { title: '跨天数', key: 'days', width: 70, align: 'center' },
      {
        title: '请假类型',
        key: 'leaveType',
        width: 120,
        render: (h, params) => {
          let typeEnum = self.$constant.getEnum(self.$constant.tchLeaveType, params.row.leaveType)
          return h('span', (typeEnum && typeEnum.text) || '—')
        }
      },
      { title: '影响课节数', key: 'lessonCount', width: 90, align: 'center' },
      {
        title: '提交时间',
        key: 'gmtCreate',
        width: 150,
        render: (h, params) => {
          return h('span', params.row.gmtCreate || '—')
        }
      },
      {
        title: '备注',
        key: 'remark',
        render: (h, params) => {
          return h('span', params.row.remark || '—')
        }
      }
    ]
    this.lessonColumns = [
      { title: '课节ID', key: 'id', width: 100, align: 'center' },
      {
        title: '上课时间',
        key: 'lsnBeginTime',
        render: (h, params) => {
          return h('span', self.formatUnix(params.row.lsnBeginTime))
        }
      },
      { title: '学生UID', key: 'uid', width: 120, align: 'center' },
      {
        title: '课节状态',
        key: 'lsnSelStatus',
        width: 120,
        render: (h, params) => {
          let statusEnum = self.$constant.getEnum(self.$constant.lsnSelStatus, params.row.lsnSelStatus)
          return h('span', (statusEnum && statusEnum.text) || '—')
        }
      }
    ]
  },
  mounted () {
    let self = this
    self.$http.post('/adminUser/listByCondition', {adminGroupId: 7, status: 1}).then(function (res) {
      if (res && res.data) {
        self.studyAdviserList = res.data
      }
    })
    self.search()
  },
  methods: {
    levelColor (level) {
      return LEVEL_COLORS[level] || '#bbb'
    },
    renderLevelTag (h, level) {
      if (!level) {
        return h('span', '—')
      }
      if (LEVEL_TAG_COLORS[level]) {
        return h('Tag', { props: { color: LEVEL_TAG_COLORS[level] } }, level)
      }
      return h('Tag', {
        style: { background: LEVEL_COLORS[level] || '#fff', borderColor: LEVEL_COLORS[level] || '#e9eaec' }
      }, [h('span', { style: { color: '#fff' } }, level)])
    },
    renderHitRule (h, r) {
      let counted = r.counted !== false
      let tips = [
        h('div', r.actual ? ('实际：' + r.actual) : '实际：—'),
        h('div', '权重 ' + (r.weight == null ? '—' : r.weight))
      ]
      if (!counted) {
        tips.push(h('div', '（同组已取更高权重，不计分）'))
      }
      return h('Tooltip', {
        props: { placement: 'top', transfer: true },
        style: { marginRight: '4px' }
      }, [
        h('Tag', {
          style: counted ? {} : { opacity: 0.45, textDecoration: 'line-through' }
        }, (r.code || '') + ' ' + (r.name || '')),
        h('div', { slot: 'content' }, tips)
      ])
    },
    reset () {
      this.queryParam = emptyQuery()
      this.statMonth = ''
      this.windowStart = ''
      this.windowEnd = ''
      this.fillingWindow = true
      this.monthDate = ''
      this.dateRange = []
      let self = this
      this.$nextTick(function () {
        self.fillingWindow = false
      })
      this.search()
    },
    onStatMonthChange (val) {
      if (this.fillingWindow) {
        return
      }
      this.statMonth = toMonthString(val)
    },
    onWindowChange (value) {
      if (this.fillingWindow) {
        return
      }
      let start = value && value.length === 2 ? toDayString(value[0]) : ''
      let end = value && value.length === 2 ? toDayString(value[1]) : ''
      if (start && end) {
        this.windowStart = start
        this.windowEnd = end
      } else {
        this.windowStart = ''
        this.windowEnd = ''
      }
    },
    applyReturnedWindow (data) {
      let statMonth = (data && data.lastMonth) || ''
      let windowStart = (data && data.windowStart) || ''
      let windowEnd = (data && data.windowEnd) || ''
      this.appliedStatMonth = statMonth
      this.appliedWindowStart = windowStart
      this.appliedWindowEnd = windowEnd
      this.fillingWindow = true
      this.monthDate = monthStringToDate(statMonth)
      this.dateRange = (windowStart && windowEnd) ? [windowStart, windowEnd] : []
      this.statMonth = statMonth
      this.windowStart = windowStart
      this.windowEnd = windowEnd
      let self = this
      this.$nextTick(function () {
        self.fillingWindow = false
      })
    },
    filterByLevel (level) {
      this.queryParam.level = level
      this.search()
    },
    onPageChange (page) {
      this.queryParam.pageIndex = page
      this.search(false)
    },
    onPageSizeChange (size) {
      this.queryParam.pageSize = size
      this.queryParam.pageIndex = 1
      this.search(false)
    },
    buildListParams () {
      let params = {
        pageIndex: this.queryParam.pageIndex,
        pageSize: this.queryParam.pageSize
      }
      if (this.queryParam.tchId) {
        params.tchId = Number(this.queryParam.tchId)
      }
      if (this.queryParam.tchName) {
        params.tchName = this.queryParam.tchName
      }
      if (this.queryParam.studyAdviserId) {
        params.studyAdviserId = this.queryParam.studyAdviserId
      }
      if (this.queryParam.level) {
        params.level = this.queryParam.level
      }
      if (this.queryParam.onlyAnomaly) {
        params.onlyAnomaly = 1
      }
      if (this.queryParam.channel) {
        params.channel = this.queryParam.channel
      }
      if (this.statMonth) {
        params.statMonth = this.statMonth
      }
      if (this.windowStart && this.windowEnd) {
        params.windowStart = this.windowStart
        params.windowEnd = this.windowEnd
      }
      return params
    },
    search (resetPage) {
      if (resetPage !== false) {
        this.queryParam.pageIndex = 1
      }
      let self = this
      self.searchLoading = true
      self.$http.post('/tch/risk-warning/list', self.buildListParams()).then(function (res) {
        self.searchLoading = false
        if (res && res.status === 'ok' && res.data) {
          self.dataList = res.data.data || []
          self.totalCount = res.data.totalCount || 0
          self.levelCounts = res.data.levelCounts || {}
          self.applyReturnedWindow(res.data)
          self.loadMonthRankScores()
        } else {
          self.dataList = []
          self.totalCount = 0
          self.levelCounts = {}
          self.$Message.error(errMsg(res, '列表加载失败'))
        }
      }).catch(function () {
        self.searchLoading = false
      })
    },
    loadMonthRankScores () {
      const rows = this.dataList || []
      if (!rows.length) {
        return
      }
      const ids = rows.map(function (row) { return row.tchId }).filter(function (id) { return id != null })
      const seq = ++this.rankScoreSeq
      const self = this
      fetchTchScoreMap(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return
        }
        applyTchScoresToRows(self, rows, 'tchId', 'monthRankScore', map)
      })
    },
    openTchInfoModal (tchId) {
      this.tchInfoId = tchId
      this.showTchInfoModal = true
    },
    formatUnix (ts) {
      if (!ts) {
        return '—'
      }
      return this.$moment(ts, 'X').format('YYYY-MM-DD HH:mm')
    },
    renderMetricCell (h, row, key, metric) {
      let v = row[key]
      if (!isPositive(v) || !row.tchId) {
        return h('span', v == null ? 0 : v)
      }
      return h('a', {
        attrs: { href: 'javascript:;' },
        on: {
          click: () => {
            this.openLeaveDetail(row, metric)
          }
        }
      }, v)
    },
    openLeaveDetail (row, metric) {
      let self = this
      let seq = self.leaveDetailSeq + 1
      self.leaveDetailSeq = seq
      self.leaveDetail = null
      self.leaveDetailMetric = metric
      let name = row.tchName || String(row.tchId)
      self.leaveDetailTitle = name + ' · ' + (METRIC_TITLES[metric] || '请假明细')
      self.showLeaveDetailModal = true
      self.leaveDetailLoading = true
      let detailParams = { tchId: row.tchId, metric: metric }
      if (self.appliedStatMonth) {
        detailParams.statMonth = self.appliedStatMonth
      }
      if (self.appliedWindowStart && self.appliedWindowEnd) {
        detailParams.windowStart = self.appliedWindowStart
        detailParams.windowEnd = self.appliedWindowEnd
      }
      self.$http.post('/tch/risk-warning/leave-detail', detailParams).then(function (res) {
        if (seq !== self.leaveDetailSeq) {
          return
        }
        if (res && res.status === 'ok' && res.data) {
          self.leaveDetail = res.data
        } else {
          self.$Message.error(errMsg(res, '明细加载失败'))
        }
      }).catch(function () {
        if (seq === self.leaveDetailSeq) {
          self.$Message.error('明细加载失败')
        }
      }).finally(function () {
        if (seq === self.leaveDetailSeq) {
          self.leaveDetailLoading = false
        }
      })
    },
    paramStep (p) {
      return p.key === 'ratio' && Number(p.value) < 10 ? 0.1 : 1
    },
    openRuleModal () {
      let self = this
      self.ruleConfig = null
      self.showRuleModal = true
      self.ruleLoading = true
      self.$http.post('/tch/risk-warning/rules', {}).then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          self.ruleConfig = JSON.parse(JSON.stringify(res.data))
        } else {
          self.$Message.error(errMsg(res, '规则加载失败'))
        }
      }).catch(function () {
        self.$Message.error('规则加载失败')
      }).finally(function () {
        self.ruleLoading = false
      })
    },
    validateRules (c) {
      if (!isInt(c.lookbackMonths) || c.lookbackMonths < 6 || c.lookbackMonths > 36) {
        return '回溯月数需为 6~36 的整数'
      }
      if (!(isInt(c.high) && isInt(c.medium) && isInt(c.watch) && isInt(c.hint))) {
        return '分档线需为整数'
      }
      if (!(c.high > c.medium && c.medium > c.watch && c.watch >= c.hint && c.hint >= 1)) {
        return '分档线需满足 高危 > 中危 > 观察 ≥ 提示 ≥ 1'
      }
      if (!isInt(c.upgradeWeight) || c.upgradeWeight < 1) {
        return '升级单条权重需为正整数'
      }
      if (!isInt(c.anomalyScore) || c.anomalyScore < 1) {
        return '异动线需为正整数'
      }
      let rules = c.rules || []
      for (let i = 0; i < rules.length; i++) {
        let r = rules[i]
        if (!isInt(r.weight) || r.weight < 0 || r.weight > 20) {
          return r.code + ' 权重需为 0~20 的整数'
        }
        if (!r.mutexGroup || !String(r.mutexGroup).trim()) {
          return r.code + ' 互斥组不能为空'
        }
        let ps = r.params || []
        for (let j = 0; j < ps.length; j++) {
          if (!isPositive(ps[j].value)) {
            return r.code + ' 参数「' + ps[j].label + '」需为正数'
          }
        }
      }
      return ''
    },
    saveRules () {
      let self = this
      let c = self.ruleConfig
      if (!c) {
        return
      }
      let msg = self.validateRules(c)
      if (msg) {
        self.$Message.error(msg)
        return
      }
      (c.rules || []).forEach(function (r) {
        r.mutexGroup = String(r.mutexGroup).trim()
      })
      self.ruleSaveLoading = true
      self.$http.post('/tch/risk-warning/rules-save', {
        rules: JSON.stringify(c)
      }).then(function (res) {
        if (res && res.status === 'ok') {
          self.$Message.success('规则已保存')
          self.showRuleModal = false
          self.search()
        } else {
          self.$Message.error(errMsg(res, '保存失败'))
        }
      }).catch(function () {
        self.$Message.error('保存失败')
      }).finally(function () {
        self.ruleSaveLoading = false
      })
    },
    resetRules () {
      let self = this
      self.$Modal.confirm({
        title: '恢复默认',
        content: '确定恢复为默认规则？当前自定义的参数、权重、互斥组和启停将被清除。',
        onOk: function () {
          self.ruleResetLoading = true
          self.$http.post('/tch/risk-warning/rules-save', { reset: 1 }).then(function (res) {
            if (res && res.status === 'ok') {
              self.$Message.success('已恢复默认规则')
              self.showRuleModal = false
              self.search()
            } else {
              self.$Message.error(errMsg(res, '恢复默认失败'))
            }
          }).catch(function () {
            self.$Message.error('恢复默认失败')
          }).finally(function () {
            self.ruleResetLoading = false
          })
        }
      })
    }
  }
}
</script>
<style scoped>
.level-bar {
  margin: 8px 0 12px;
  padding: 8px 12px;
  background: #f8f8f9;
  border-radius: 4px;
  line-height: 24px;
  overflow: hidden;
}
.level-item {
  display: inline-block;
  margin-right: 20px;
  cursor: pointer;
  color: #495060;
}
.level-item:hover,
.level-item-active {
  color: #2d8cf0;
}
.level-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 4px;
}
.rule-table-wrap {
  max-height: 480px;
  overflow-y: auto;
  border: 1px solid #e9eaec;
}
.rule-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}
.rule-table th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #f8f8f9;
  font-weight: normal;
  color: #495060;
}
.rule-table th,
.rule-table td {
  padding: 6px 8px;
  border-bottom: 1px solid #e9eaec;
  text-align: left;
  vertical-align: middle;
}
.rule-desc {
  color: #80848f;
}
.rule-disabled td {
  background: #fafafa;
  color: #bbbec4;
}
.rule-param {
  display: inline-block;
  margin: 2px 8px 2px 0;
  white-space: nowrap;
}
.rule-param-label {
  margin-right: 4px;
}
.rule-muted {
  color: #bbbec4;
}
.detail-summary {
  margin-bottom: 10px;
  color: #80848f;
}
.detail-sub-title {
  margin-bottom: 8px;
  font-weight: bold;
  color: #495060;
}
</style>



// WEBPACK FOOTER //
// TchRiskWarningList.vue?4b4c5e56